module.exports = __webpack_public_path__ + "static/media/bellabyte-uniforme-polo-personalizado-768x591.08198c92.jpg";